import React, { useEffect, useState } from "react";
import s from "./DetailSalvta.module.css";

//service
import masiveDistributionServices from "../../../../../api/delivery/masiveDistribution";

//assets
import { useTranslation } from "react-i18next";
import { currencyFormat } from "../../../../../helpers/currency";
import { useSelector } from "react-redux";

//materialUi
import {
  Grid,
  TableContainer,
  Table,
  TableHead,
  TableBody,
  TableCell,
  TableRow,
  CircularProgress,
  Snackbar,
  Alert,
} from "@mui/material";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import BallotIcon from "@mui/icons-material/Ballot";
import Pager from "../../../../Shared/Pagination/Pagination";

const cellStyles = {
  fontFamily: "Roboto, sans-serif",
  fontSize: ".9rem",
  fontWeight: "400",
  borderBottom: "1px solid rgba(0, 0, 0, 0.455)",
};

const DetailSalvta = ({ detail, setDetail }) => {
  const { textColor } = useSelector((state) => state.local);
  const { t } = useTranslation();

  const [loading, setLoading] = useState(false);
  const [items, setItems] = useState([]);
  const [openError, setOpenError] = useState(false);

  const [page, setPage] = useState(1);
  const [pageCustom, setPageCustom] = useState(1);
  const [pageSize, setPageSize] = useState(10);
  const [totalPages, setTotalPages] = useState(1);
  const [sort, setSort] = useState({
    criteria: "ASC",
    field: "agency",
  });

  const getDetailData = () => {
    setLoading(true);    
    masiveDistributionServices
      .getSalvtaDetail(page, pageSize, sort, detail?.data?.id)
      .then((res) => {
        setItems(res?.content);
        setTotalPages(res?.totalPages);
        setLoading(false);
      })
      .catch(() => {
        setOpenError(true);
        setLoading(false);
      });
  };

  const handleSort = (item) => {
    setSort((prev) => ({
      criteria:
        prev.field === item
          ? prev.criteria === "DESC"
            ? "ASC"
            : "DESC"
          : "DESC",
      field: item,
    }));
  };

  useEffect(() => {
    getDetailData();
  }, [page, pageSize, sort]);

  return (
    <Grid container className={s.container}>
      <Grid item container xs={11} className={s.header}>
        <Grid item xs={1} lg={1}>
          <ArrowBackIcon
            sx={{ fontSize: "2rem", color: "primary.main", mr: 1 }}
            onClick={() => setDetail({ status: false, data: {} })}
            className={s.arrow}
          />
        </Grid>
        <Grid item xs={11} lg={11} className={s.titleContainer}>
          <BallotIcon sx={{ fontSize: "2rem", color: "primary.main", mr: 1 }} />
          <h4>{`${t("drawDetail")}: ${detail.data.raffle.number}`}</h4>
        </Grid>
      </Grid>

      <Grid item xs={11} className={s.data}>
        {loading ? (
          <Grid
            item
            xs={12}
            sx={{
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              height: "50vh",
            }}
          >
            <CircularProgress size="2rem" />
          </Grid>
        ) : items?.length ? (
          <TableContainer className={s.tableContainer}>
            <Table stickyHeader>
              <TableHead>
                <TableRow>
                  <TableCell
                    sx={{
                      ...cellStyles,
                      backgroundColor: "primary.main",
                      color: textColor,
                      fontWeight: 500,
                      backgroundColor: "primary.main",
                    }}
                    align="center"
                    onClick={() => handleSort("agency")}
                  >
                    {`${t("agency")} ${sort.field === "agency" ? (sort.criteria === "DESC" ? "▼" : "▲") : ""}`}
                  </TableCell>
                  <TableCell
                    sx={{
                      ...cellStyles,
                      backgroundColor: "primary.main",
                      color: textColor,
                      fontWeight: 500,
                      backgroundColor: "primary.main",
                    }}
                    align="center"
                    onClick={() => handleSort("distributed")}
                  >
                    {`${t("distributed")} ${sort.field === "distributed" ? (sort.criteria === "DESC" ? "▼" : "▲") : ""}`}
                  </TableCell>
                  <TableCell
                    sx={{
                      ...cellStyles,
                      backgroundColor: "primary.main",
                      color: textColor,
                      fontWeight: 500,
                      backgroundColor: "primary.main",
                    }}
                    align="center"
                    onClick={() => handleSort("returned")}
                  >
                    {`${t("returned")} ${sort.field === "returned" ? (sort.criteria === "DESC" ? "▼" : "▲") : ""}`}
                  </TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {items?.map((item, i) => {
                  return (
                    <React.Fragment key={i}>
                      <TableRow
                        sx={{
                          backgroundColor:
                            i % 2 === 0 ? "#dbdbdb76" : "#dbdbdd12",
                        }}
                      >
                        <TableCell sx={{ ...cellStyles }} align="center">
                          {item.agency || "-"}
                        </TableCell>
                        <TableCell sx={{ ...cellStyles }} align="center">
                          {item.distributed}
                        </TableCell>
                        <TableCell sx={{ ...cellStyles }} align="center">
                          {item.returned}
                        </TableCell>
                      </TableRow>
                    </React.Fragment>
                  );
                })}
              </TableBody>
            </Table>
          </TableContainer>
        ) : (
          <Grid
            item
            xs={12}
            sx={{
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              height: "50vh",
              fontSize: "1.5rem",
              fontWeight: 300,
            }}
          >
            {t("noResults")}
          </Grid>
        )}
      </Grid>
      <Grid
        item
        xs={12}
        sx={{ display: "flex", justifyContent: "center", alignItems: "center" }}
      >
        <Pager
          pageSize={pageSize}
          setPageSize={setPageSize}
          page={page}
          setPage={setPage}
          totalPages={totalPages}
          pageCustom={pageCustom}
          setPageCustom={setPageCustom}
        />
      </Grid>
      <Snackbar
        open={openError}
        autoHideDuration={6000}
        onClose={() => setOpenError(false)}
        anchorOrigin={{
          vertical: "bottom",
          horizontal: "right",
        }}
      >
        <Alert
          variant="filled"
          onClose={() => setOpenError(false)}
          severity="error"
          sx={{ width: "100%" }}
        >
          {t("tryInOtherMoment")}
        </Alert>
      </Snackbar>
    </Grid>
  );
};

export default DetailSalvta;
